module.exports = "/fonts/eppt-picturemark-d-576873c71a5269c85d63787bec25b05b.svg";